import { List, OrderedMap } from "immutable";

import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import {
  ContentStat,
  ContentStats
} from "../../../../models/state/contentStats";
import * as statSelectors from "./stat";
import { ContentStatsSelectors } from "./types";

export function getContentStat(
  contentStats: ContentStats,
  contentId: string
): ContentStat | null | undefined {
  return contentStats.get(contentId);
}

export function hasContentStat(
  contentStats: ContentStats,
  contentId: string
): boolean {
  return contentStats.has(contentId);
}

// @ts-ignore
export const {
  getId,
  getTimesStudied,
  getLastStudied,
  getLastScore,
  getLastContentModuleId,
  lastTryWasIncorrect
}: ContentStatsSelectors<ContentStats> = composeSelectors(
  getContentStat,
  statSelectors
);

export function getContentStats(
  contentStats: ContentStats,
  contentIds: List<string>
): ContentStats {
  // @ts-ignore
  return contentIds.reduce((acc, contentId) => {
    const contentStat = getContentStat(contentStats, contentId);
    return contentStat ? acc.set(contentId, contentStat) : acc; // $FlowFixMe
  }, OrderedMap());
}
